import { BrowserRouter } from 'react-router-dom';

import './App.scss';
import Routes from './routes';
import AUTH_CONFIG from './utils/authConfig';
import Login from 'containers/Login';

function App() {
  return (
    <Login>
      <BrowserRouter basename={AUTH_CONFIG.appBasePath}>
        <Routes />
      </BrowserRouter>
    </Login>
  );
}

export default App;
